// Environment-specific configuration for Demo User Pool
const targetEnv = import.meta.env.VITE_APP_ENV || "dev";

// Demo User Pool configuration with unified environment variables
const demoConfig = (() => {
  // For Storybook mock values
  if (targetEnv === "sb") {
    return {
      region: "ap-northeast-1",
      identityPoolId: "ap-northeast-1:mock-identity-pool",
      userPoolId: "ap-northeast-1_MockPool",
      userPoolClientId: "mock-client-id"
    };
  }

  // For all other environments, use unified environment variables
  return {
    region: "ap-northeast-1",
    identityPoolId: import.meta.env.VITE_DEMO_IDENTITY_POOL_ID || "",
    userPoolId: import.meta.env.VITE_DEMO_USER_POOL_ID || "",
    userPoolClientId: import.meta.env.VITE_DEMO_USER_POOL_CLIENT_ID || ""
  };
})();

const config = {
  Auth: {
    Cognito: {
      region: demoConfig.region,
      identityPoolId: demoConfig.identityPoolId,
      userPoolId: demoConfig.userPoolId,
      userPoolClientId: demoConfig.userPoolClientId,
      loginWith: {
        email: true
      }
    }
  },
  Storage: {
    S3: {
      region: "ap-northeast-1"
    }
  }
};

export default config;
